import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import { useEffect, useState, Suspense, lazy } from "react";
import ProtectedRoute from "./protectedRoute";
import ErrorPage from "./components/Misc/Error/error";
import PageNotFound from "./components/Misc/404page/pageNotFound";
import WalletStatementsPage from "./pages/WalletStatements/WalletStatementsPage";
import CP from "./pages/menus/CP";
import Dice from "./pages/menus/autoGames/Dice";
import SpinAndWin from "./pages/menus/autoGames/spinAndWin";
import DirectionWheel from "./pages/menus/autoGames/directionwheelgames";
import ScratchAndWin from "./pages/menus/autoGames/scratchAndWin";
import TransferOnlinePage from "./components/Wallet/transferPoints/TransferOnlinePage";
import TransferOfflinePage from "./components/Wallet/transferPoints/TransferOfflinePage";
import ForgotPasswordForm from "./components/login/forgotPassword";
import { useAppStore } from "./appStore";
import { api_url } from "./apiUtils";
import axios from "axios";
import GroupTransfer from "./components/Wallet/transferPoints/GroupTransferPage";
import MenuProtectedRoute from "./MenuProtectedRoute";
import ForcedPasswordChangeDialog from "./components/login/ForcedPasswordChangeDialog";
import { Box } from "@mui/material";

// Lazy load the components
const Login = lazy(() => import("./pages/login/login"));
const CustomerChatbot = lazy(() => import("./components/chatbot/CustomerChatbot"));
const SMPay = lazy(() => import("./pages/smpay/SMPay"));
const Register = lazy(() => import("./pages/register/register"));
const Home = lazy(() => import("./pages/home/home"));
const Profile = lazy(() => import("./pages/profile/profile"));
const Wallet = lazy(() => import("./pages/wallet/wallet"));
const DepositReport = lazy(() => import("./pages/wallet/depositReport"));
const WithdarwRequest = lazy(() => import("./pages/wallet/withdrawRequest"));
const ChooseMenus = lazy(() => import("./pages/menus/selectMenus"));
const Result = lazy(() => import("./pages/result/result"));
const Bulk90 = lazy(() => import("./pages/menus/Bulk 90"));
const Game90 = lazy(() => import("./pages/menus/Game90"));
const Game9 = lazy(() => import("./pages/menus/Game9"));
const AllInOne = lazy(() => import("./pages/menus/AllInOne"));
const SinglePana = lazy(() => import("./pages/menus/SinglePana"));
const DoublePana = lazy(() => import("./pages/menus/DoublePana"));
const TriplePana = lazy(() => import("./pages/menus/TriplePana"));
const TotalMenu = lazy(() => import("./pages/menus/TotalMenu"));
const DynamicMenuPage = lazy(() => import("./pages/menus/DynamicMenuPage"));
const JodiFamilyPana = lazy(() => import("./pages/menus/JodiFamilyPana"));
const FamilyPana = lazy(() => import("./pages/menus/FamilyPana"));
const Adhik = lazy(() => import("./pages/menus/Adhik"));
const ResultDownload = lazy(() => import("./pages/result/ResultDownload"));
const History = lazy(() => import("./pages/History/History"));
const HolidayList = lazy(() => import("./pages/HolidayList/HolidayList"));
const ZeroPana = lazy(() => import("./pages/menus/ZeroPana"));
const RP = lazy(() => import("./pages/menus/RP"));
const MP = lazy(() => import("./pages/menus/MP"));
const Game1000 = lazy(() => import("./pages/menus/Game1000"));
const Game10000 = lazy(() => import("./pages/menus/Game10000"));
const CutAkda = lazy(() => import("./pages/menus/CutAkda"));

function App() {
  const [online, setOnline] = useState(window.navigator.onLine);
  const [profileHydrated, setProfileHydrated] = useState(
    !sessionStorage.getItem("accesstoken"),
  );
  const { profileData, setReferralUserCount, setProfileData } = useAppStore();
  const passwordChangeRequired = Boolean(
    sessionStorage.getItem("accesstoken") && profileData?.mustChangePassword,
  );

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accesstoken");
    if (!accessToken) {
      setProfileHydrated(true);
      return;
    }
    setProfileHydrated(false);
    axios
      .get(`${api_url}auth/profile`, {
        headers: { accesstoken: accessToken },
      })
      .then((response) => setProfileData(response.data?.userProfile))
      .catch(() => {})
      .finally(() => setProfileHydrated(true));
  }, [setProfileData]);

  useEffect(() => {
    if (!profileData?._id || profileData.mustChangePassword) return;
    // Fetch user details from the API
    axios
      .get(`${api_url}user/customer-users`, {
        headers: { accesstoken: sessionStorage.getItem("accesstoken") },
      })
      .then((response) => {
        if (response.data.status === "success") {
          console.log("res", response.data.user.length);
          const users = response.data;
          setReferralUserCount(users?.userCount);
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, [profileData?._id, profileData?.mustChangePassword, setReferralUserCount]);

  // vendor online or offline using window event
  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!online) {
    return <ErrorPage />;
  }

  return (
    <>
      <BrowserRouter>
        <Helmet defaultTitle="S - M ( M-India ) Spot-Money">
          <link rel="icon" href="/sm-logo.png" />
        </Helmet>
        <ToastContainer
          position="bottom-right"
          theme="dark"
          hideProgressBar={true}
          autoClose={2000}
          transition={Slide}
        />
        <ForcedPasswordChangeDialog />

        <Suspense
          fallback={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          }
        >
          {profileHydrated && !passwordChangeRequired ? (
          <Routes>
            <Route path="/smpay" element={<ProtectedRoute><SMPay /></ProtectedRoute>} />
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPasswordForm />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/home/menus"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            {/* games */}
            <Route
              path="/game/play/Bulk 90"
              element={
                <MenuProtectedRoute>
                  <Bulk90 />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Game 90"
              element={
                <MenuProtectedRoute>
                  <Game90 />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Game 9"
              element={
                <MenuProtectedRoute>
                  <Game9 />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/All in one"
              element={
                <MenuProtectedRoute>
                  <AllInOne />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/SP"
              element={
                <MenuProtectedRoute>
                  <SinglePana />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/DP"
              element={
                <MenuProtectedRoute>
                  <DoublePana />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/TP"
              element={
                <MenuProtectedRoute>
                  <TriplePana />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Total"
              element={
                <MenuProtectedRoute>
                  <TotalMenu />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Jodi Family"
              element={
                <MenuProtectedRoute>
                  <JodiFamilyPana />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Pana Family"
              element={
                <MenuProtectedRoute>
                  <FamilyPana />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Adhik"
              element={
                <MenuProtectedRoute>
                  <Adhik />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/ZP"
              element={
                <MenuProtectedRoute>
                  <ZeroPana />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/RP"
              element={
                <MenuProtectedRoute>
                  <RP />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/MP"
              element={
                <MenuProtectedRoute>
                  <MP />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Game 1000"
              element={
                <MenuProtectedRoute>
                  <Game1000 />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Game 10000"
              element={
                <MenuProtectedRoute>
                  <Game10000 />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/Cut Akda"
              element={
                <MenuProtectedRoute>
                  <CutAkda />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/CP"
              element={
                <MenuProtectedRoute>
                  <CP />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/dice-roll"
              element={
                <MenuProtectedRoute>
                  <Dice />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/spin-and-win"
              element={
                <MenuProtectedRoute>
                  <SpinAndWin />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/direction-wheel-game"
              element={
                <MenuProtectedRoute>
                  <DirectionWheel />
                </MenuProtectedRoute>
              }
            />
            <Route
              path="/game/play/scratch-and-win"
              element={
                <MenuProtectedRoute allowRefresh>
                  <ScratchAndWin />
                </MenuProtectedRoute>
              }
            />
            {/* ----end-games----- */}

            {/* Dynamic Menus */}
            <Route
              path="/play/:name"
              element={
                <MenuProtectedRoute>
                  <DynamicMenuPage />
                </MenuProtectedRoute>
              }
            />
            {/*------- Dynamic Menus end ------*/}

            <Route
              path="/wallet/manage-points"
              element={
                <ProtectedRoute>
                  <Wallet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/deposit-reports"
              element={
                <ProtectedRoute>
                  <DepositReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/withdraw-reports"
              element={
                <ProtectedRoute>
                  <WithdarwRequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet-statements"
              element={
                <ProtectedRoute>
                  <WalletStatementsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/result"
              element={
                // <ProtectedRoute>
                <Result />
                // </ProtectedRoute>
              }
            />
            <Route
              path="/download_results"
              element={
                // <ProtectedRoute>
                <ResultDownload />
                // </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings/select-menus"
              element={
                <ProtectedRoute>
                  <ChooseMenus />
                </ProtectedRoute>
              }
            />

            <Route
              path="/history"
              element={
                // <ProtectedRoute>
                <History />
                // </ProtectedRoute>
              }
            />
            <Route
              path="/holiday-list"
              element={
                <ProtectedRoute>
                  <HolidayList />
                </ProtectedRoute>
              }
            />
            {/* transfer points */}
            <Route
              path="/transfer/online"
              element={
                <ProtectedRoute>
                  <TransferOnlinePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transfer/offline"
              element={
                <ProtectedRoute>
                  <TransferOfflinePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transfer/group"
              element={
                <ProtectedRoute>
                  <GroupTransfer />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<PageNotFound />} />
          </Routes>
          ) : !profileHydrated ? (
            <Box
              sx={{
                minHeight: "100vh",
                display: "grid",
                placeItems: "center",
                color: "#1e2466",
                fontWeight: 700,
              }}
            >
              Loading your account...
            </Box>
          ) : null}
        </Suspense>
        {profileHydrated && !passwordChangeRequired && profileData?.role === "customer" && sessionStorage.getItem("accesstoken") && (
          <Suspense fallback={null}><CustomerChatbot /></Suspense>
        )}
      </BrowserRouter>
    </>
  );
}

export default App;
